import React from 'react'

export default function GamesList({games, onShowGame, onShowOpenGame}) {
  const showGame = (game) => {
    game.open ? onShowOpenGame(game.id) : onShowGame(game.id)
  }

  return <table className='table table-striped'>
    <thead>
      <tr>
        <th>#&nbsp;Field</th>
        <th>Name</th>
        <th>Date & Time</th>
        <th>Location</th>
        <th>Balance</th>
        <th>Price</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      { 
        games.map((game, index) => {
          return <tr key={game.id}>
            <td><p>{game.field}</p></td>
            <td><p>{game.master}</p></td>
            <td><p>{game.date}</p></td>
            <td><p>{game.location}</p></td>
            <td><p>$ {parseFloat(game.balance).toFixed(2)}</p></td>
            <td><p>$ {parseFloat(game.cost).toFixed(2)}</p></td>
            <td>
              <a className='btn btn-info clickable' onClick={() => showGame(game)}>Open</a>
            </td>
          </tr>
        })
      }
    </tbody>
  </table>
}
